export enum UserRoleId {
    Individual = 'individual',
    Wholesale = 'wholesale',
}

export type UserRole = {
    id: UserRoleId;
    name: string;
};

export type User = {
    name: string | null;
    id: number;
    role: UserRole;
    phone: string | null;
    email: string | null;
    push_token: string | null;
};
